export const theme = {
    name: 'Stroyka',
    author: {
        name: 'Sabetsoft',
        profile_url: 'https://www.instagram.com/sabetsoft/'
    }
};
